/**
 * Result of pruning the blockchain.
 */
export default class MoneroPruneResult {
    constructor(result) {
        Object.assign(this, result);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (this.getIsPruned())
            json.isPruned = this.getIsPruned();
        if (this.getPruningSeed())
            json.pruningSeed = this.getPruningSeed();
        return json;
    }
    getIsPruned() {
        return this.isPruned;
    }
    setIsPruned(isPruned) {
        this.isPruned = isPruned;
        return this;
    }
    getPruningSeed() {
        return this.pruningSeed;
    }
    setPruningSeed(pruningSeed) {
        this.pruningSeed = pruningSeed;
        return this;
    }
}
